// extracted by mini-css-extract-plugin
module.exports = {"section__header":"Section_section__header__VJ8Z7","section__headline":"Section_section__headline__2DuEd"};